import {Caregiver, Patient} from '@drl/shared/models';
import {User} from '@drl/core/auth/models/user.model';

export class PatientCaregiver {
  patient: Patient & User;
  careGiver?: Caregiver & User;
}
